import { useEffect, useState } from 'react';
import { finApi } from '../../api/finance.js';
import { useAuth } from '../../contexts/AuthContext.jsx';
import InvoiceLineEditor from '../../components/InvoiceLineEditor.jsx';

export default function VendorInvoices() {
  const { can } = useAuth();
  const [items, setItems] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [error, _setError] = useState(null);
  const canCreate = can('vendor_invoice', 'create');

  function refresh() {
    finApi.vendorInvoices().then((d) => setItems(d?.items || []));
  }
  useEffect(() => {
    refresh();
    finApi.vendors({ active: true }).then((d) => setVendors(d?.items || []));
    finApi.accounts({ active: true }).then((d) => setAccounts((d || []).filter((a) => ['expense', 'asset'].includes(a.category_type))));
  }, []);

  return (
    <section>
      <header className="page-header">
        <h1>Vendor Invoices</h1>
        {canCreate && <button className="btn primary" onClick={() => setShowForm((s) => !s)}>{showForm ? 'Close' : '+ New Invoice'}</button>}
      </header>

      {error && <div className="alert error">{error}</div>}

      {showForm && (
        <NewVendorInvoice
          vendors={vendors}
          accounts={accounts}
          onCancel={() => setShowForm(false)}
          onSaved={() => { setShowForm(false); refresh(); }}
        />
      )}

      <div className="card">
        <table className="data-table">
          <thead><tr><th>Invoice #</th><th>Vendor</th><th>Date</th><th>Due</th><th>Total</th><th>Paid</th><th>Status</th></tr></thead>
          <tbody>
            {items.map((i) => (
              <tr key={i.id}>
                <td><code>{i.invoice_no}</code></td>
                <td>{i.vendor_name}</td>
                <td>{i.date}</td>
                <td>{i.due_date}</td>
                <td>{i.currency} {Number(i.total).toFixed(2)}</td>
                <td>{Number(i.paid_amount).toFixed(2)}</td>
                <td><span className={`chip status-${i.status}`}>{i.status}</span></td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={7} className="muted">No invoices yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}

function NewVendorInvoice({ vendors, accounts, onSaved, onCancel }) {
  const [vendorId, setVendorId] = useState('');
  const [invoiceNo, setInvoiceNo] = useState('');
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [dueDate, setDueDate] = useState(new Date(Date.now() + 30 * 86400000).toISOString().slice(0, 10));
  const [lines, setLines] = useState([{ description: '', quantity: 1, unitPrice: 0, accountId: '', taxRate: 0 }]);
  const [error, setError] = useState(null);

  async function submit(e) {
    e.preventDefault();
    setError(null);
    try {
      await finApi.createVendorInvoice({
        vendorId,
        invoiceNo,
        date,
        dueDate,
        currency: 'USD',
        lines,
      });
      onSaved();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed');
    }
  }

  return (
    <form onSubmit={submit} className="card form-card">
      <div className="grid-form">
        <label>
          Vendor
          <select value={vendorId} onChange={(e) => setVendorId(e.target.value)} required>
            <option value="">Select…</option>
            {vendors.map((v) => <option key={v.id} value={v.id}>{v.name}</option>)}
          </select>
        </label>
        <label>Invoice #<input value={invoiceNo} onChange={(e) => setInvoiceNo(e.target.value)} required /></label>
        <label>Date<input type="date" value={date} onChange={(e) => setDate(e.target.value)} required /></label>
        <label>Due<input type="date" value={dueDate} onChange={(e) => setDueDate(e.target.value)} required /></label>
      </div>

      <InvoiceLineEditor lines={lines} setLines={setLines} accounts={accounts} />

      {error && <div className="alert error">{error}</div>}
      <div className="actions">
        <button type="button" className="btn ghost" onClick={onCancel}>Cancel</button>
        <button type="submit" className="btn primary">Record Invoice</button>
      </div>
    </form>
  );
}
